import { makeCommsPage } from './commsPage'
import { CommsAgentActionsView } from '../components/views/commsAgentActionsView'

export default makeCommsPage({
    title: 'Agent actions',
    probeUrl: 'comms/inbox/stats',
    View: CommsAgentActionsView,
    className: 'commsAgentActions',
    viewRendersHeader: true,
})
